import React, { useEffect } from 'react';

const PARTICLE_SHAPES = ['\u2713', '\u2605', '\u25C6', '\u25CF', '\u2699', '+'];
const PARTICLE_COLORS = ['#246dcb', '#00a6a6', '#ffb000', '#ff5d73', '#7b61ff', '#38a169'];
const PARTICLES = Array.from({ length: 56 }, (_, index) => ({
    shape: PARTICLE_SHAPES[index % PARTICLE_SHAPES.length],
    color: PARTICLE_COLORS[index % PARTICLE_COLORS.length],
    angle: (index * 137.508) % 360,
    distance: 260 + (index % 7) * 42,
    size: 18 + (index % 5) * 4,
    delay: (index % 8) * 45,
}));

const PerfectRepairCelebration = ({ celebration, onComplete }) => {
    useEffect(() => {
        if (!celebration) return undefined;

        const timer = window.setTimeout(onComplete, 3200);
        return () => window.clearTimeout(timer);
    }, [celebration, onComplete]);

    if (!celebration) return null;

    return (
        <div className="perfect-repair-celebration" aria-live="polite">
            <div className="perfect-repair-particles" aria-hidden="true">
                {PARTICLES.map((particle, index) => (
                    <span
                        key={`${celebration}-${index}`}
                        style={{
                            '--particle-angle': `${particle.angle}deg`,
                            '--particle-color': particle.color,
                            '--particle-distance': `${particle.distance}px`,
                            '--particle-size': `${particle.size}px`,
                            '--particle-delay': `${particle.delay}ms`,
                        }}
                    >
                        {particle.shape}
                    </span>
                ))}
            </div>
            <div className="perfect-repair-message">
                <span className="perfect-repair-check" aria-hidden="true">✓</span>
                <span>Another one back on the road!</span>
            </div>
        </div>
    );
};

export default PerfectRepairCelebration;
